import ProfileRequestCard from "./ProfileRequestCard";

const AcceptRequest = () => {
  return (
    <div className="flex flex-col justify-start items-center w-full overflow-x-hidden">
      <ProfileRequestCard AcceptHide={true} />
      <ProfileRequestCard AcceptHide={true} />
      <ProfileRequestCard AcceptHide={true} />
      <ProfileRequestCard AcceptHide={true} />
      <ProfileRequestCard AcceptHide={true} />
      <ProfileRequestCard AcceptHide={true} />
      <ProfileRequestCard AcceptHide={true} />
      <ProfileRequestCard AcceptHide={true} />
      <ProfileRequestCard AcceptHide={true} />
      <ProfileRequestCard AcceptHide={true} />
    </div>
  );
};
export default AcceptRequest;
